import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import MaterialSelect from "../../../components/MasterSelect";
import URL from "../../Utils/url";
import { fromGlobalId } from "../../../lib/decoded/rawPk";
import {
  GetbrandDetails,
  GetCategoryDetails,
  getProductDetail,
  GetUOMDetails,
  GetWarehouseDetails,
} from "../../../lib/graphQL/graphQuery";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  addProductRestService,
  deleteProductService,
  updateProductRestService,
} from "../../../lib/appUtliz/ProductService";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";

export default function AddProduct() {
  const [isFocused, setIsFocused] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const [pendingLoading, setPendingLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus , errormessage, setErrormessage} = useError();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const [categoryData, setCategoryData] = useState();
  const [brandData, setBrandData] = useState();
  const [uomData, setUomData] = useState();
  const params = useLocation();

  const id = params.search.slice(1);
  const [wareHouseData, setWareHouseData] = useState();
  const [productData, setProductData] = useState({
    // Product Details
    productName: "",
    category: "",
    brand: "",
    productCost: "",
    sellingPrice: "",
    skuNumber: "",
    hsnNumber: "",
    uom: "",
    reorderLevel: "",
    location: "",
    tax: "",
    productImage: null,
    description: "",
    previewURL: "",

    // Uom Type Status
    productNameStatus: "unchecked",
    categoryStatus: "unchecked",
    brandStatus: "unchecked",
    productCostStatus: "unchecked",
    sellingPriceStatus: "unchecked",
    skuNumberStatus: "unchecked",
    hsnNumberStatus: "unchecked",
    uomStatus: "unchecked",
    reorderLevelStatus: "unchecked",
    locationStatus: "unchecked",
    taxStatus: "unchecked",
    descriptionStatus: "unchecked",
    productImageStatus: "unchecked",
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  useEffect(() => {
    if (id) {
      fetchviewValue();
    }
  }, [id]);

  //Fetch Brand,UOM,Category and Warehouse
  const fetchData = () => {
    request(BASEURL, GetbrandDetails).then((res) => {
      setBrandData(res.allBrandDetail);
    });
    request(BASEURL, GetUOMDetails).then((res) => {
      setUomData(res.allUom);
    });
    request(BASEURL, GetCategoryDetails).then((res) => {
      setCategoryData(res.allProductcategory);
    });
    request(BASEURL, GetWarehouseDetails).then((res) => {
      setWareHouseData(res.allWarehouse);
    });
  };
  //Fetch Data By ID
  const fetchviewValue = async () => {
    try {
      const res = await request(BASEURL, getProductDetail, {
        id: id,
      });

      const v = res.getProductdetail;
      setSelectedData(v);
      if (v.id == id) {
        setProductData({
          hsnNumber: v.HSNNumber,
          hsnNumberStatus: "success",
          skuNumber: v.SKU,
          skuNumberStatus: "success",
          tax: v.Tax,
          taxStatus: "success",
          uom: {
            value: v.UOM?.id,
            label: v.UOM?.uomName,
          },
          uomStatus: "success",
          brand: {
            value: v.brand?.id,
            label: v.brand?.brandName,
          },
          brandStatus: "success",
          category: {
            value: v.category?.id,
            label: v.category?.categoryName,
          },
          categoryStatus: "success",
          description: v.description,
          descriptionStatus: "success",
          location: {
            value: v.location?.id,
            label: v.location?.warehouseName,
          },
          locationStatus: "success",
          productCost: v.productCost,

          productCostStatus: "success",
          productName: v.productName,
          productNameStatus: "success",
          reorderLevel: v.reorderLevel,
          reorderLevelStatus: "success",
          sellingPrice: v.sellingPrice,
          sellingPriceStatus: "success",
          previewURL: URL + "media/" + v?.productImage.replace(" ", "%20"),
        });
      }
    } catch (err) {
      console.error("Couldn't Fetch Data: ",err.message);
    }
  }

   //Add Mutation
 const handleAddProductData = async () => {

  const formData = new FormData();
  formData.append("user", rawPk);
  formData.append("product_name", productData.productName);
  formData.append("category", productData.category?.value);
  formData.append("brand", productData.brand?.value);
  formData.append("product_cost", productData.productCost);
  formData.append("selling_price", productData.sellingPrice);
  formData.append("SKU", productData.skuNumber);
  formData.append("HSN_number", productData.hsnNumber);
  formData.append("UOM", productData.uom?.value);
  formData.append("reorder_level", productData.reorderLevel);
  formData.append("location", productData.location?.value || "");
  formData.append("Tax", productData.tax);
  formData.append("description", productData.description);
  if (productData.productImage) {
    formData.append("product_image", productData.productImage);
  }
  setConfirmationDialog({
    open: true,
    title: "Confirmation",
    message: "Are you sure do you want to submit your details.",
    showCancel: true,
    showConfirm: true,
    onConfirm: async () => {
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(true);
      const  { createStatus, errormessage }= await addProductRestService(formData);
      setCirleLoading(false);
      if (createStatus) {
        setSuccessStatus(true);
        setSucessTitle("Product Created");
        setTimeout(() => {
          setSuccessStatus(false);
          navigate("/product");
        }, 1000);
      } else {
        setErrorStatus(true);
        setErrormessage(errormessage);
        setTimeout(() => {
          setErrorStatus(false);
        }, 3000);
      }
    },
    onCancel: () => {
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    },
  });
};

  //Update Mutation
  const handleEditProductChange = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const formData = new FormData();
        formData.append("user", rawPk);
        formData.append("product_name", productData.productName);
        formData.append("category", productData.category?.value);
        formData.append("brand", productData.brand?.value);
        formData.append("product_cost", productData.productCost);
        formData.append("selling_price", productData.sellingPrice);
        formData.append("SKU", productData.sku);
        formData.append("HSN_number", productData.hsnNumber);
        formData.append("UOM", productData.uom?.value);
        formData.append("reorder_level", productData.reorderLevel);
        formData.append("location", productData.location?.value || "");
        formData.append("Tax", productData.tax);
        formData.append("description", productData.description);
        if (productData.productImage?.name) {
          formData.append("product_image", productData.productImage);
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const updateStatus = await updateProductRestService(formData, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Product Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/product");
          }, 1000);
        } else {
          setErrorStatus(true);
          
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Function
  const handleDelteProduct = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await deleteProductService(id);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Product Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/product");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Submit Validation
  const checkAllFields = () => {
      let allowSubmit = false;
      if (
        productData.productNameStatus === "success" &&
        productData.categoryStatus === "success" &&
        productData.productCostStatus === "success" &&
        productData.sellingPriceStatus === "success" &&
        productData.uomStatus === "success" &&
        (productData.locationStatus === "success" ||
          productData.locationStatus === "unchecked") &&
        productData.taxStatus === "success" &&
        (productData.brandStatus === "unchecked" ||
          productData.brandStatus === "success") &&
        (productData.skuNumberStatus === "unchecked" ||
          productData.skuNumberStatus === "success") &&
        (productData.hsnNumberStatus === "unchecked" ||
          productData.hsnNumberStatus === "success") &&
        (productData.reorderLevelStatus === "unchecked" ||
          productData.reorderLevelStatus === "success") &&
        (productData.descriptionStatus === "unchecked" ||
          productData.descriptionStatus === "success")
      ) {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
      return allowSubmit;
  };

  //Handle Change
  const handleProductDataChange = (event, selectEvent) => {
    let productState = { ...productData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "category":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              productState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              productState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "brand":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              productState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              productState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "uom":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              productState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              productState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "location":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              productState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              productState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }

      productState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "productName":
          {
            const alphaNumericLengthRegex = new RegExp("^[A-Za-z0-9\\s!@#$%^&*()_+={}[\\]:;\"'<>,.?/-]{2,100}$");
            if (alphaNumericLengthRegex.test(event.target.value?.trim())) {
              productState[event.target.name + "Status"] = "success";
            } else {
              productState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "productCost":
          {
            const value = event.target.value?.trim();

            const isValidNumeric = /^[0-9.]+$/.test(value);

            const exceedsMaxLength = value.length > 9;

            if (value === "") {
              productState[event.target.name + "Status"] = "unchecked"; // No validation for empty input
              productState[event.target.name + "ErrorMessage"] = "";
            } else if (!isValidNumeric) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Product Cost should accept only numbers.";
            } else if (exceedsMaxLength) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Product Cost should not exceed 9 characters.";
            } else {
              productState[event.target.name + "Status"] = "success";
              productState[event.target.name + "ErrorMessage"] = "";
            }
          }
          break;

        case "sellingPrice":
          {
            const value = event.target.value?.trim();

            
            const isValidNumeric = /^[0-9.]+$/.test(value);

          
            const exceedsMaxLength = value.length > 9;

            if (value === "") {
              productState[event.target.name + "Status"] = "unchecked"; // No validation for empty input
              productState[event.target.name + "ErrorMessage"] = "";
            } else if (!isValidNumeric) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Selling Price should accept only numbers.";
            } else if (exceedsMaxLength) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Selling Price should not exceed 9 characters.";
            } else {
              productState[event.target.name + "Status"] = "success";
              productState[event.target.name + "ErrorMessage"] = "";
            }
          }
          break;
        case "skuNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              productState[event.target.name + "Status"] = "success";
            } else {
              productState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "hsnNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9]{1,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              productState[event.target.name + "Status"] = "success";
            } else {
              productState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "reorderLevel":
          {
            const value = event.target.value?.trim();

            const isValidNumeric = /^[0-3]+$/.test(value);

            const exceedsMaxLength = value.length > 3;

            if (value === "") {
              productState[event.target.name + "Status"] = "unchecked";
              productState[event.target.name + "ErrorMessage"] = "";
            } else if (!isValidNumeric) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Reorder Level should accept only numbers.";
            } else if (exceedsMaxLength) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Reorder Level should not exceed 3 characters.";
            } else {
              productState[event.target.name + "Status"] = "success";
              productState[event.target.name + "ErrorMessage"] = "";
            }
          }
          break;

          case "tax": {
            const value = event.target.value?.trim();
          
            
            const isValidNumeric = /^[0-9]{1,2}$/.test(value);
          
           
            const hasInvalidCharacters = /[^0-9]/.test(value);
          
            if (value === "") {
              productState[event.target.name + "Status"] = "unchecked"; // No validation for empty input
              productState[event.target.name + "ErrorMessage"] = "";
            } else if (hasInvalidCharacters) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Tax should accept only numeric values.";
            } else if (!isValidNumeric) {
              productState[event.target.name + "Status"] = "error";
              productState[event.target.name + "ErrorMessage"] =
                "Tax must be a numeric value and should not exceed 2 digits.";
            } else {
              productState[event.target.name + "Status"] = "success";
              productState[event.target.name + "ErrorMessage"] = "";
            }
          }
          break;
          
        case "description":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,250}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              productState[event.target.name + "Status"] = "success";
            } else {
              productState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      productState[event.target.name] = event.target.value;
    }

    setProductData(productState);
  };

  //Discard Function
  const handleDiscardButtn = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setProductData({
      hsnNumber: selectedData.HSNNumber,
      hsnNumberStatus: "success",
      skuNumber: selectedData.SKU,
      skuNumberStatus: "success",
      tax: selectedData.Tax,
      taxStatus: "success",
      uom: {
        value: selectedData.UOM?.id,
        label: selectedData.UOM?.uomName,
      },
      uomStatus: "success",
      brand: {
        value: selectedData.brand?.id,
        label: selectedData.brand?.brandName,
      },
      brandStatus: "success",
      category: {
        value: selectedData.category?.id,
        label: selectedData.category?.categoryName,
      },
      categoryStatus: "success",
      description: selectedData.description,
      descriptionStatus: "success",
      location: {
        value: selectedData.location?.id,
        label: selectedData.location?.warehouseName,
      },
      locationStatus: "success",
      productCost: selectedData.productCost,
      productCostStatus: "success",
      productName: selectedData.productName,
      productNameStatus: "success",
      reorderLevel: selectedData.reorderLevel,
      reorderLevelStatus: "success",
      sellingPrice: selectedData.sellingPrice,
      sellingPriceStatus: "success",
      previewURL: URL + "media/" + selectedData?.productImage.replace(" ", "%20"),
    });
  };

  //Cancel Function
  const handleCancelProductData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        navigate("/product");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Product Image Handle Change Function
  const handleProductImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setProductData({
          ...productData,
          productImage: file,
          productImageStatus: "",
          previewURL: reader.result,
        });
        //   setImageURL(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setProductData({
        ...productData,
        productImage: "",
        productImageStatus: "unchecked",
        previewURL: "",
      });
    }
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Product Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDelteProduct}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              )  :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Product Details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
              : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Product Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
           <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                                     <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                                     <MaterialTypography
                                                     sx={{color:'#460058',fontFamily:'Aptos'}}
                                                       component="label"
                                                       variant="body2"
                                                       fontWeight="700"
                                                     >
                                                       Product Information
                                                     </MaterialTypography>
                                                   </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Product Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="productName"
                  size="small"
                  placeholder="Enter Product Name"
                  value={productData.productName}
                  onChange={handleProductDataChange}
                  error={
                    productData.productNameStatus === "error" ? true : false
                  }
                  success={
                    productData.productNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {productData.productNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Product Name should be maximum 100 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="category"
                  size="small"
                  value={productData.category}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleProductDataChange} //selectedValue, event
                  options={categoryData?.map((value) => {
                    return {
                      value: value.id,
                      label: value.categoryName,
                    };
                  })}
                  error={productData.categoryStatus === "error" ? true : false}
                  success={
                    productData.categoryStatus === "success" ? true : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Brand <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="brand"
                  size="small"
                  value={productData.brand}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleProductDataChange} //selectedValue, event
                  options={brandData?.map((value) => {
                    return {
                      value: value.id,
                      label: value.brandName,
                    };
                  })}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={productData.brandStatus === "error" ? true : false}
                  success={productData.brandStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Product Cost <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="productCost"
                  size="small"
                  placeholder="Enter Product Cost"
                  value={productData.productCost}
                  onChange={handleProductDataChange}
                  error={
                    productData.productCostStatus === "error" ? true : false
                  }
                  success={
                    productData.productCostStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {productData.productCostStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      {productData.productCostErrorMessage}
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Selling Price <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="sellingPrice"
                  placeholder="Enter Selling Price"
                  value={productData.sellingPrice}
                  onChange={handleProductDataChange}
                  size="small"
                  error={
                    productData.sellingPriceStatus === "error" ? true : false
                  }
                  success={
                    productData.sellingPriceStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {productData.sellingPriceStatus === "error" &&
                  productData.sellingPrice && (
                    <FormControl error>
                      <FormHelperText>
                        {productData.sellingPriceErrorMessage}
                      </FormHelperText>
                    </FormControl>
                  )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="uom"
                  size="small"
                  value={productData.uom}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleProductDataChange} //selectedValue, event
                  options={uomData?.map((value) => {
                    return {
                      value: value.id,
                      label: value.uomName,
                    };
                  })}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={productData.uomStatus === "error" ? true : false}
                  success={productData.uomStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Reorder Level
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reorderLevel"
                  size="small"
                  placeholder="Enter Reorder Level"
                  value={productData.reorderLevel}
                  onChange={handleProductDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={
                    productData.reorderLevelStatus === "error" ? true : false
                  }
                  success={
                    productData.reorderLevelStatus === "success" ? true : false
                  }
                />
                {productData.reorderLevelStatus === "error" &&
                  productData.reorderLevel && (
                    <FormControl error>
                      <FormHelperText>
                        {productData.reorderLevelErrorMessage}
                      </FormHelperText>
                    </FormControl>
                  )}
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Tax <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="tax"
                  size="small"
                  placeholder="Enter Tax"
                  value={productData.tax}
                  onChange={handleProductDataChange}
                  disabled={togglePage?.view === true ? true : false}
                  error={productData.taxStatus === "error" ? true : false}
                  success={productData.taxStatus === "success" ? true : false}
                />
                {productData.taxStatus === "error" && productData.tax && (
                  <FormControl error>
                    <FormHelperText>
                      {productData.taxErrorMessage}
                    </FormHelperText>
                  </FormControl>
                )}

              </Grid>
              <Grid size={{ xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Product Image
                  </MaterialTypography>
                </MaterialBox>
                {togglePage?.view === true ? null : (
                  <MaterialInput
                    name="productImage"
                    type="file"
                    size="small"
                    placeholder=" eg. Samsung..."
                    onChange={handleProductImageChange}
                    error={
                      productData.productImageStatus === "error" ? true : false
                    }
                    success={
                      productData.productImageStatus === "success"
                        ? true
                        : false
                    }
                    disabled={togglePage?.view === true ? true : false}
                  />
                )}
                {productData.productImageStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Brand Image Must be in png, jpg, jpeg..
                    </FormHelperText>
                  </FormControl>
                )}
                {productData.previewURL && (
                  <MaterialBox mt={2}>
                    <img
                      src={productData.previewURL}
                      alt="Brand Logo Preview"
                      width="100"
                    />
                  </MaterialBox>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Product Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  size="small"
                  placeholder="Write description..."
                  value={productData.description}
                  onChange={handleProductDataChange}
                  error={
                    productData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    productData.descriptionStatus === "success" ? true : false
                  }
                  multiline
                  rows={3}
                  disabled={togglePage?.view === true ? true : false}
                />
                {productData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description should be allows maximum 200 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
          mt={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleDiscardButtn}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={handleEditProductChange}
              >
                update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <> 
              <MaterialButton
                sx={{ m: 1 }}
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleCancelProductData}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 1 }}
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={handleAddProductData}
              >
                Submit
              </MaterialButton>
            </>
          ) : null}
        </MaterialBox>
        </CardContent>
        
      </Card>
    </DashboardLayout>
  );
}
